import type { ReadonlyURLSearchParams } from "next/navigation";

export type GetSearchParamsLDAttributesProps = {
  searchParams: ReadonlyURLSearchParams;
};

export const getSearchParamsLDAttributes = ({
  searchParams,
}: GetSearchParamsLDAttributesProps) => {
  const ldAttributes = {};

  if (searchParams.has("interestQuery"))
    ldAttributes["interestQuery"] = searchParams.get("interestQuery");

  if (searchParams.has("referrer"))
    ldAttributes["referrer"] = searchParams.get("referrer");

  if (searchParams.has("utmCampaign"))
    ldAttributes["utmCampaign"] = searchParams.get("utmCampaign");

  if (searchParams.has("utmMedium"))
    ldAttributes["utmMedium"] = searchParams.get("utmMedium");

  if (searchParams.has("utmSource"))
    ldAttributes["utmSource"] = searchParams.get("utmSource");

  return ldAttributes;
};
